var _defs, _polygon, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfilSpumaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bf327d15-e23b-41f4-8f68-5a9c3aca4f9f",
    "data-name": "profil_spuma",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a7918629-9808-4df4-b1e6-3e0388c8466d,.bcacb1f9-358e-467e-bfe6-609926903d61,.f82685aa-739d-44cc-9092-28324cac0f54{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.bcacb1f9-358e-467e-bfe6-609926903d61{stroke-width:10px;}.f82685aa-739d-44cc-9092-28324cac0f54{stroke-width:5px;}.a7918629-9808-4df4-b1e6-3e0388c8466d{stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "profil_spuma_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "bcacb1f9-358e-467e-bfe6-609926903d61",
    points: "5 15 5 195 195 195 195 80 80 80 41 90 41 5 5 15"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f82685aa-739d-44cc-9092-28324cac0f54",
    x1: 41.43,
    y1: 92.09,
    x2: 6.5,
    y2: 102.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f82685aa-739d-44cc-9092-28324cac0f54",
    x1: 41.43,
    y1: 93.17,
    x2: 41.43,
    y2: 194.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f82685aa-739d-44cc-9092-28324cac0f54",
    x1: 7.5,
    y1: 143.5,
    x2: 41.43,
    y2: 143.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "f82685aa-739d-44cc-9092-28324cac0f54",
    x1: 92.5,
    y1: 79.5,
    x2: 92.5,
    y2: 194.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "f82685aa-739d-44cc-9092-28324cac0f54",
    x1: 160.5,
    y1: 79.5,
    x2: 160.5,
    y2: 195.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "f82685aa-739d-44cc-9092-28324cac0f54",
    x1: 173.85,
    y1: 80,
    x2: 173.85,
    y2: 194.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "f82685aa-739d-44cc-9092-28324cac0f54",
    x1: 194.5,
    y1: 137.5,
    x2: 160.5,
    y2: 137.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "f82685aa-739d-44cc-9092-28324cac0f54",
    x1: 193.5,
    y1: 97.5,
    x2: 160.5,
    y2: 97.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "f82685aa-739d-44cc-9092-28324cac0f54",
    x1: 21.75,
    y1: 10.35,
    x2: 21.75,
    y2: 97.14
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "f82685aa-739d-44cc-9092-28324cac0f54",
    x1: 41.43,
    y1: 119.38,
    x2: 92.5,
    y2: 119.38
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 56,
    cy: 159,
    r: 6.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 82,
    cy: 157,
    r: 5.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 50.5,
    cy: 165.5,
    r: 9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 60,
    cy: 187,
    r: 4.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 73,
    cy: 180,
    r: 6.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 71.5,
    cy: 157.5,
    r: 5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 48.5,
    cy: 148.5,
    r: 5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 51.5,
    cy: 179.5,
    r: 5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 51,
    cy: 125,
    r: 4.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 46.5,
    cy: 136.5,
    r: 3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 56,
    cy: 136,
    r: 5.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 77.5,
    cy: 134.5,
    r: 5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 63.5,
    cy: 151.5,
    r: 4
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 61.5,
    cy: 176.5,
    r: 5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 84.5,
    cy: 190.5,
    r: 7
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 46.5,
    cy: 188.5,
    r: 5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 86.5,
    cy: 133.5,
    r: 4
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 66.5,
    cy: 127.5,
    r: 8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 68.89,
    cy: 167.77,
    r: 4.58
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 75,
    cy: 146,
    r: 6.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 58,
    cy: 145,
    r: 3.5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 84.5,
    cy: 170.5,
    r: 8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 87,
    cy: 148,
    r: 4.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 49,
    cy: 111,
    r: 6.5
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 66.5,
    cy: 104.5,
    r: 5
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 85.52,
    cy: 112.53,
    r: 5
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 60,
    cy: 113,
    r: 3.5
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 63.5,
    cy: 93.5,
    r: 4
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 73.5,
    cy: 95.5,
    r: 4
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 56,
    cy: 100,
    r: 4.5
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 46,
    cy: 97,
    r: 3.5
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 85,
    cy: 90,
    r: 4.5
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 76.5,
    cy: 86.5,
    r: 4
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 83.5,
    cy: 101.5,
    r: 5
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 75,
    cy: 106,
    r: 3.5
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 71,
    cy: 119,
    r: 8.5
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 88,
    cy: 125,
    r: 3.5
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "a7918629-9808-4df4-b1e6-3e0388c8466d",
    cx: 89.5,
    cy: 174.5,
    r: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilSpumaWhite);
export default __webpack_public_path__ + "static/media/profil_spuma_white.30ffda636785b1ceb67f553175af8bd8.svg";
export { ForwardRef as ReactComponent };